import * as yup from 'yup';

import { requiredNumberField } from '@blockpulse3/web-client/forms';

export const schema = yup.object({
  investAmount: requiredNumberField,
  fundsSourceCertificate: yup.string().optional(),
});
